var _use, _symbol;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmazonWebServicesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 67 63",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aws-service-dependencies-icon",
    x: 1,
    y: 1
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "aws-service-dependencies-icon",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.26 60.886l-14.27-5.12v-20.91l14.27 4.86zm2.6 0l14.27-5.12v-20.91L33.86 39.72zm-15.4-27.6l14.4-4.066 13.392 4.32-13.392 4.546zm-4.184-1.6L0 26.55V5.61l14.27 4.86zm2.614 0l14.27-5.12V5.61l-14.274 4.884zm-15.4-27.6L15.89 0l13.392 4.32L15.89 8.866zm46.104 27.6l-14.27-5.12V5.61l14.27 4.86zm2.6 0l14.27-5.12V5.61l-14.27 4.86zm-15.4-27.6L49.194.02l13.392 4.32-13.392 4.546z",
    stroke: "none",
    fill: "#f90"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonWebServicesIcon);
export default __webpack_public_path__ + "static/media/amazon-web-services-icon.276a61f2.svg";
export { ForwardRef as ReactComponent };